import { render, staticRenderFns } from "./NotificationFull.vue?vue&type=template&id=93494690&scoped=true&"
import script from "./NotificationFull.vue?vue&type=script&lang=js&"
export * from "./NotificationFull.vue?vue&type=script&lang=js&"
import style0 from "./NotificationFull.vue?vue&type=style&index=0&id=93494690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93494690",
  null
  
)

export default component.exports